class o extends Error {
  constructor(r, e) {
    super(r), this.code = e;
  }
}
export {
  o as PaymentGatewayError
};
//# sourceMappingURL=paymentGatewayError.js.map
